import {
    video_more_from_base_section_update,
    video_more_from_base_section_error,
    video_more_from_base_section_null,
} from "./actions";

import { transformAllContentItems } from "../../utils/dataTransform/library";
import { transformForLayouts } from "../../utils/dataTransform/ContentQueryWidget/library";
import { getVideoItemsByCategorySlugs } from "../../fetch/graphql/requests/video/library";
import { DEFAULT_SWIMLANE_LAYOUT } from "../../components/LayoutFactory/constants";

export const fetchMoreFromBaseSection = (categorySlugs, fetchProps = {}) => {
    const { limit = 10, sourceId = "", path = "", streamType } = fetchProps;
    return async (dispatch) => {
        const numItemsToFetch = limit + 5;
        try {
            const response = await getVideoItemsByCategorySlugs(
                categorySlugs,
                numItemsToFetch,
                streamType
            );
            const allItems = response?.data?.allContentItems?.nodes ?? [];
            const filteredItems = allItems
                .filter((item) => item.sourceId !== sourceId)
                .slice(0, limit);

            const transformedItems =
                transformAllContentItems(filteredItems) ?? [];
            const cardGridItems = transformedItems?.length
                ? transformForLayouts(
                      transformedItems,
                      DEFAULT_SWIMLANE_LAYOUT,
                      path
                  )
                : [];
            return dispatch(video_more_from_base_section_update(cardGridItems));
        } catch (error) {
            return dispatch(video_more_from_base_section_error(error));
        }
    };
};

export const nullifyMoreFromBaseSection = () => {
    return (dispatch) => {
        dispatch(video_more_from_base_section_null());
    };
};
